/* 曹操傳・第 1 章：間行東歸（190 年）
 * 從洛陽（西）往東，大路要經過兩道關（關牆南北橫貫，只有大路上的關門能過），東邊是中牟縣城（縣城裡有縣獄）。 */
export const PASSES = [2700, 4700], ROAD_Y = 2200, TOWN = { x: 6900, y: 2200, hw: 650, hh: 520 }, JAIL = [6750, 2050], EXIT = [7900, 2200];
const T = 34, gap = 150;
const pass = (x) => [[x, (200 + ROAD_Y - gap) / 2, T, (ROAD_Y - gap - 200) / 2], [x, (ROAD_Y + gap + 4300) / 2, T, (4300 - ROAD_Y - gap) / 2]];
const N = TOWN.y - TOWN.hh, S = TOWN.y + TOWN.hh, Wx = TOWN.x - TOWN.hw, E = TOWN.x + TOWN.hw;
export const TOWN_GATES = [[Wx, ROAD_Y], [E, ROAD_Y]];
export default {
  id: 'zhongmou', name: '中牟', W: 8400, H: 4400, seed: 1902,
  bases: [[600, ROAD_Y], EXIT],
  walls: [
    ...pass(PASSES[0]), ...pass(PASSES[1]),
    [TOWN.x, N, TOWN.hw + T, T], [TOWN.x, S, TOWN.hw + T, T],
    [Wx, (N + ROAD_Y - 130) / 2, T, (ROAD_Y - 130 - N) / 2], [Wx, (S + ROAD_Y + 130) / 2, T, (S - ROAD_Y - 130) / 2],
    [E, (N + ROAD_Y - 130) / 2, T, (ROAD_Y - 130 - N) / 2], [E, (S + ROAD_Y + 130) / 2, T, (S - ROAD_Y - 130) / 2],
  ],
  roads: [{ pts: [[400, ROAD_Y], [1600, ROAD_Y + 60], [PASSES[0], ROAD_Y], [3700, ROAD_Y - 60], [PASSES[1], ROAD_Y], [5800, ROAD_Y + 40], [TOWN.x, ROAD_Y], [EXIT[0], ROAD_Y]], w: 150 }],
  rocks: [[1600, 1000, 380, 180], [3700, 3400, 420, 200], [5700, 1100, 380, 180], [1500, 3500, 360, 180]],
  woods: 0.45,
  sight: 0.8,
  clearings: [[PASSES[0], ROAD_Y, 380], [PASSES[1], ROAD_Y, 380], [TOWN.x, TOWN.y, 700], [600, ROAD_Y, 360]],
  villages: [{ x: TOWN.x + 120, y: TOWN.y + 120, n: 7, r: 400 }],
  tents: [{ x: PASSES[0] - 260, y: ROAD_Y - 330, n: 2, r: 140, col: '#5a3a30', flag: '關' }, { x: PASSES[1] - 260, y: ROAD_Y - 330, n: 2, r: 140, col: '#5a3a30', flag: '關' }],
  grass: [[1900, 1800, 240, 110], [3800, 2700, 240, 110], [5600, 1900, 240, 110]],
};
